import cx from 'classnames';
import { CheckIcon, CrossIcon } from '@wkda/icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Select({
  className,
  options,
  placeholderOption,
  value,
  isValid,
  showVisualFeedback = false,
  mktSelector,
  qaSelector,
  ...selectProps
}) {
  const status = typeof isValid === 'undefined' ? 'not-validated' : isValid === true ? 'valid' : 'invalid';
  const showPlaceholder = placeholderOption && !value;
  return /*#__PURE__*/_jsxs("div", {
    className: "custom-select__container icon-select__container",
    children: [/*#__PURE__*/_jsxs("select", {
      ...selectProps,
      className: cx('custom-select', className, {
        'is-invalid': status === 'invalid'
      }),
      value: value,
      "data-mkt-selector": mktSelector,
      "data-qa-selector": qaSelector || mktSelector,
      "data-qa-selector-value": value,
      children: [placeholderOption && /*#__PURE__*/_jsx("option", {
        value: '',
        disabled: true,
        children: placeholderOption
      }), Array.isArray(options) ? options.map(({
        value,
        label
      }) => {
        const usableValue = typeof value === 'boolean' ? String(value) : value;
        return /*#__PURE__*/_jsx("option", {
          value: usableValue,
          "data-qa-selector-value": value,
          children: label
        }, usableValue);
      }) : Object.entries(options).map(([key, itemOptions]) => /*#__PURE__*/_jsx("optgroup", {
        label: key,
        children: itemOptions.map(({
          value,
          label
        }) => {
          const usableValue = typeof value === 'boolean' ? String(value) : value;
          return /*#__PURE__*/_jsx("option", {
            value: usableValue,
            children: label
          }, usableValue);
        })
      }, key))]
    }), showPlaceholder ? /*#__PURE__*/_jsx("div", {
      className: "custom-select__placeholder",
      "aria-hidden": true,
      children: placeholderOption
    }) : null, status === 'valid' && showVisualFeedback ? /*#__PURE__*/_jsx(CheckIcon, {
      className: "icon-select__icon text-success"
    }) : null, status === 'invalid' && showVisualFeedback ? /*#__PURE__*/_jsx(CrossIcon, {
      className: "icon-select__icon icon-select__icon-cross text-danger"
    }) : null]
  });
}